// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_content__Pa3ld {
  position: relative;
  width: 100%;
  height: 100%;
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/templates/partials/Particules/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":[".content {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: contents;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `styles_content__Pa3ld`
};
export default ___CSS_LOADER_EXPORT___;
